import React from 'react';
import styles from './CircularProgress.module.css';

function CircularProgress() {
  return (
    <svg className={styles.root} viewBox="0 0 50 50">
      <circle cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
    </svg>
  );
}

export default CircularProgress;
